import React from 'react';
import { decodeToken, useCredentials, useSetCredentials } from '@dentalux/security';
import { isPast } from 'date-fns';
import * as S from './Menu.styles';
const Menu = ({
  trigger,
  children,
  justifyContent = 'left'
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const {
    token
  } = useCredentials();
  const setCredentials = useSetCredentials();
  const open = Boolean(anchorEl);
  const handleClick = event => {
    if (token && isPast(decodeToken(token).exp * 1000)) {
      setCredentials(null, 'local');
    }
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(S.Trigger, {
    onClick: handleClick
  }, trigger), /*#__PURE__*/React.createElement(S.Menu, {
    open: open,
    justifyContent: justifyContent,
    onClose: handleClose,
    onClick: handleClose
  }, children));
};
export default Menu;